export function AlterNav(el) {
    var body = document.body;
    var mainEl = el;
    var topEl = el.querySelector('.bilvision-header-top');
    var bottomEl = el.querySelector('.bilvision-header-bottom');
    var mobileTrigger = el.querySelector('#navTriggerer');
    if (!topEl || !bottomEl) {
        return;
    }
    var config = {
        topElHeight: topEl.clientHeight,
        bottomElHeight: bottomEl.clientHeight,
        classes: {
            sticky: 'sticky',
            animate: 'animate',
            triggered: 'triggered'
        },
        scrollPos: 0,
        breakPoint: 1000,
        mobileTriggered: false
    };
    window.addEventListener('scroll', function () {
        if (body.getBoundingClientRect().top > config.scrollPos) {
            // Scrolling up
            mainEl.classList.add(config.classes.animate);
            mainEl.style.top = '0';
            if (window.scrollY <= config.topElHeight) {
                mainEl.classList.remove(config.classes.animate);
            }
        }
        else {
            // Scrolling down
            if (window.scrollY >= config.topElHeight) {
                mainEl.classList.add(config.classes.sticky);
                mainEl.style.top = "-".concat(config.topElHeight, "px");
                body.style.paddingTop = "".concat(config.topElHeight + config.bottomElHeight, "px");
            }
            else {
                mainEl.classList.remove(config.classes.sticky);
                mainEl.style.top = '0';
                body.style.paddingTop = '0';
            }
        }
        config.scrollPos = body.getBoundingClientRect().top;
    });
    if (!mobileTrigger || window.innerWidth >= config.breakPoint) {
        return;
    }
    mobileTrigger.addEventListener('click', function () {
        if (!config.mobileTriggered) {
            bottomEl.classList.add(config.classes.triggered);
            config.mobileTriggered = true;
            return;
        }
        bottomEl.classList.remove(config.classes.triggered);
        config.mobileTriggered = false;
    });
    var submenuTriggers = bottomEl.querySelectorAll('.empori-header-nav-link > .submenu-trigger');
    if (submenuTriggers) {
        submenuTriggers.forEach(function (trigger) {
            var _a;
            var submenu = (_a = trigger.parentElement) === null || _a === void 0 ? void 0 : _a.nextElementSibling;
            var triggered = false;
            if (submenu) {
                trigger.addEventListener('click', function (event) {
                    event.preventDefault();
                    if (!triggered) {
                        trigger.classList.add(config.classes.triggered);
                        submenu.classList.add(config.classes.triggered);
                        triggered = true;
                        return;
                    }
                    trigger.classList.remove(config.classes.triggered);
                    submenu.classList.remove(config.classes.triggered);
                    triggered = false;
                });
            }
        });
    }
}
